import { Modal, Box, Typography, Card } from "@mui/material";
import { icons } from "../../assets/icons/icons";

const SuccessModal = ({
  open,
  onClose,
  message = "Player kept unsold",
  sold = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 250,
          p: 5,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0, 0, 0, 0.15)",
          textAlign: "center",
        }}
      >
        <img src={icons.greentick} alt="success" />
        {sold && (
          <Typography
            variant="body1"
            sx={{ fontWeight: "500", fontSize: "1.1rem", mt: "1rem" }}
          >
            Player sold to:
          </Typography>
        )}
        <Typography
          variant="body1"
          sx={{ fontWeight: "600", fontSize: "1.2rem", mt: "1rem" }}
        >
          {message}
        </Typography>
      </Card>
    </Modal>
  );
};

export default SuccessModal;
